import { Record } from '@gonfalon/immutable-shim/immutableShim';
import { validateRecord } from '@gonfalon/legacy-form-validation/validationUtils';

import type { RepositoryForm } from '#utils/codeRefs/types';

export class RepositoryFormRecord extends Record<RepositoryForm>({
  enabled: true,
}) {
  validate() {
    return validateRecord(this);
  }

  is(other: RepositoryFormRecord) {
    try {
      return this.enabled === other.enabled;
    } catch {
      // could fail to parse as JSON
      return false;
    }
  }
}

export function createRepositoryFormRecord(props = {}) {
  return props instanceof RepositoryFormRecord ? props : new RepositoryFormRecord(props);
}
